import Notiflix from 'notiflix';
import { log as journalLog } from "../../utils/journal";

// Alerts: one at a time, top centre, light cards with a coloured edge (see .notiflix-notify in index.css)
Notiflix.Notify.init({
    position: 'center-top',
    distance: '18px',
    width: '440px',
    borderRadius: '10px',
    fontFamily: 'Poppins',
    fontSize: '14px',
    timeout: 5000,
    messageMaxLength: 300,
    plainText: true,
    showOnlyTheLastOne: true,
    clickToClose: true,
    cssAnimationStyle: 'from-top',
    cssAnimationDuration: 300,
    success: { background: '#ecfdf3', textColor: '#05603a', notiflixIconColor: '#12b76a' },
    failure: { background: '#fef3f2', textColor: '#912018', notiflixIconColor: '#d92d20' },
    warning: { background: '#fffaeb', textColor: '#93370d', notiflixIconColor: '#f79009' },
    info: { background: '#eff8ff', textColor: '#194185', notiflixIconColor: '#2e90fa' },
});

Notiflix.Loading.init({
    fontFamily: 'Poppins',
    backgroundColor: 'rgba(16, 24, 40, 0.35)',
    svgColor: '#008080',
    messageColor: '#ffffff',
    messageFontSize: '15px',
    clickToClose: false,
});

export const loaderStart = () => {
    Notiflix.Loading.standard('Loading...');
}

export const loaderEnd = () => {
    Notiflix.Loading.remove()
}

//RealTime Notifications
export const notification = (status, msg = "Success") => {
    if (status) {
        Notiflix.Loading.remove()
        Notiflix.Notify.success(msg)
    }
    else {
        Notiflix.Loading.remove()
        Notiflix.Notify.failure(msg)
        // Every error the candidate is shown goes into their journal
        journalLog("ERROR_SHOWN", { d: msg })
    }

}
